import { API_ENDPOINTS, API_URL } from "../../constants";
import axiosInstance from "../../core/apiService/webApiService";
import { UserHome } from "../../pages/home/home.model";

//api call to change password
const ChangePassword = async (userHome: UserHome, token: UserHome): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.post(`${API_URL}${API_ENDPOINTS.HOME.CHANGE_PASSWORD}`, userHome, config);
  return response.data;
};

//api call to logout
const logout = async (token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const response = await axiosInstance.post(`${API_URL}${API_ENDPOINTS.AUTH.LOGOUT}`, {}, config);
  return response.data;
};

//api call to fetch sidebar and cards items
const fetchSidebarAndCardItems = async (token: UserHome): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await axiosInstance.get(`${API_URL}${API_ENDPOINTS.HOME.HOME_FETCH_SIDEBAR_AND_CARD_ITEMS}`, config);
  return response.data;
};

//api call to fetch about us
const fetchAboutUs = async (token: UserHome): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await axiosInstance.get(`${API_URL}${API_ENDPOINTS.HOME.ABOUT_US}`, config);
  return response.data;
};

const downloadLanguageFile = async (
  {
    filename, // en / fr
    reg_code
  }: {
    filename: string;
    reg_code: string;
  },
  token: string
): Promise<any> => {

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await axiosInstance.get(
    `${API_URL}${API_ENDPOINTS.LANG_FILE.DOWNLOAD_LANG_FILE}?reg_code=${reg_code}&filename=${filename}`,
    config
  );

  return response.data;
};


const uploadLanguageFile = async (
  file: File,
  language: string, // en / fr
  reg_code: string,
  token: string
): Promise<any> => {

  const formData = new FormData();
  formData.append("file", file);
  formData.append("language", language);

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const response = await axiosInstance.post(
    `${API_URL}${API_ENDPOINTS.LANG_FILE.UPLOAD_LANG_FILE}${reg_code}`,
    formData,
    config
  );

  return response.data;
};

const homeService = {
  ChangePassword,
  logout,
  fetchSidebarAndCardItems,
  fetchAboutUs,
  downloadLanguageFile,
  uploadLanguageFile

};

export default homeService;
